import React from 'react';
import {List} from 'immutable';
import Dialog from '@material-ui/core/Dialog';
import {TagData} from 'stores/files/FileUploadStore';
import {Library} from '@store/@types/records/Library';
import User from 'records/User';
import {LibraryTabContent} from '@components/call-card/LibraryTabContent';
import {FileUploadId} from 'records/CoachingReviewFileUpload';
import {UserComment} from 'records/UserComment';
import Typography from '@material-ui/core/Typography';
import DialogContent from '@material-ui/core/DialogContent';

interface AddHighlightToLibraryDialogProps {
  open: boolean;
  libraries: Library[];
  tags: List<TagData>;
  sessionUser: User;
  callId: FileUploadId;
  userHighlights: List<UserComment>;
  selectedHighlight: UserComment;
  onClose: () => void;
}

export const AddHighlightToLibraryDialog: React.FC<AddHighlightToLibraryDialogProps> = props => {
  return (
    <Dialog open={props.open} onClose={props.onClose}>
      <DialogContent>
        <Typography variant="h2" style={{marginBottom: 20, fontWeight: 600}}>
          Add highlight to Library
        </Typography>
        <LibraryTabContent
          libraries={props.libraries}
          tags={props.tags}
          callId={props.callId}
          sessionUser={props.sessionUser}
          userHighlights={props.userHighlights}
          preSelectedHighlight={props.selectedHighlight}
          onClose={props.onClose}
        />
      </DialogContent>
    </Dialog>
  );
};
